module.exports = require("./../../_gen/starling/events/ResizeEvent");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/events/ResizeEvent.js
// module id = 183
// module chunks = 0